import { initCookieConsent } from './consent'
import { registerGtagLoader } from './gtag'
import { registerFacebookPixelLoader } from './facebookPixel'
import { registerHubspotLoader } from './hubspot'

// Called once at app root (see gatsby-browser.tsx).
export const initAnalytics = (): void => {
  initCookieConsent()
  registerGtagLoader()
  registerFacebookPixelLoader()
  registerHubspotLoader()
}
